import type {QueryParams} from '@jetbrains/teamcity-ui/dist/utils'

import {pipelinesApi} from '../services/pipelinesApi'

import type {AppThunk} from 'src/actions/types'
import {loadEndpoint, type LoadedEndpoints} from 'src/routes/loadEndpoint'
import type {PipelineId} from 'src/types'
import {DEFAULT_NAME as DEFAULT_BRANCH_NAME} from 'src/utils/branchNames'
import {isPipelinesBranchedYamlSettingsEnabled} from 'src/utils/featureToggles'

export const preloadEditPipelinePage =
  (pipelineId: PipelineId, queryParams: QueryParams): AppThunk<LoadedEndpoints> =>
  dispatch => {
    const branch =
      isPipelinesBranchedYamlSettingsEnabled && queryParams.branch
        ? queryParams.branch
        : DEFAULT_BRANCH_NAME
    return [
      dispatch(
        loadEndpoint(pipelinesApi.endpoints.getPipelineById, {
          id: pipelineId,
          branch,
        }),
      ),
    ]
  }
